import L3DrugDisposalList from '../l3/L3DrugDisposalList'
import { useFormSelector } from '../../../redux/formStoreHooks'

const L4DrugDisposalList = () => {
	const models = useFormSelector(state => state.formModel.drugDisposal)
	return <L3DrugDisposalList models={models} />
}

export default L4DrugDisposalList
